import React from "react";

// External
import styled, { css } from "styled-components";
import { FiChevronLeft } from "react-icons/fi";
import { navigate } from "gatsby";

// Internal
import useMediaQuery from "../../hooks/use-media-query";
import IconButton from "../../components/form/IconButton";
import { Flex } from "../../styles/global-styles";
import {
  fontFamily,
  colors,
  breakpoints,
  getProjectTheme,
  sectionRhythm,
} from "../../../theme";
import ContactMeSection from "../contact-me-section";
import ContainerScroll from "../../components/container-scroll";
import { ProjectHero, caseStudyBodyStyles } from "./project-page-media";
import Testimonials from "../reviews-section/Testimonials";

const projectTheme = getProjectTheme("blank-auction-house");
// Styles

const BlogContainer = styled.div`
  width: calc(100vw - 48px);
  padding-top: ${sectionRhythm.paddingY.mobile}px;
  margin: 0 auto;

  @media only screen and (min-width: ${breakpoints.tablet}) {
    width: 65%;
    max-width: 800px;
    padding-top: ${sectionRhythm.paddingY.desktop}px;
    margin: 0 auto;
  }
  @media only screen and (min-width: 900px) {
    width: 60%;
  }
`;

const BlogTitle = styled.h1`
  margin: 0 0 16px;
  font-family: ${fontFamily.extraBold};
  font-size: 24px;

  @media only screen and (min-width: ${breakpoints.tablet}) {
    font-size: 44px;
    margin: 0 0 24px;
  }
`;
const Video = styled.video`
  //   width: 100%;
  height: 102%;
  border-radius: 6px !important;
  transform: scale(1.02);
  // box-shadow: 2px 2px 12px rgba(0, 0, 0, 0.1);
  @media only screen and (min-width: ${breakpoints.tablet}) {
    border-radius: 12px;
  }
`;

const VideoContainer = styled.div`
  width: ${(props) => (props.isMobileCover ? "96%" : "100%")};
  border: 4px solid white;
  border-radius: 6px !important;
  overflow: hidden;
  box-sizing: border-box;
  background-image: linear-gradient(180deg, ${colors.white}, ${colors.white});
  box-shadow: 17px 17px 48px 0 rgb(0 0 0 / 12%);
  margin-top: 1.5rem;
`;

const BlogContentContainer = styled.div`
  ${caseStudyBodyStyles}
`;
const OverviewSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  margin-bottom: 0;
`;

const OverviewItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media only screen and (min-width: 1000px) {
    flex-direction: row;
  }
`;

const OverviewItem = styled.div`
  margin-bottom: 1rem;

  ${(props) =>
    props.isSeventyPercent &&
    css`
      width: 100%;
      @media only screen and (min-width: 1000px) {
        width: 70%;
      }
    `}
  ${(props) =>
    props.isThirtyPercent &&
    css`
      width: 100%;
      @media only screen and (min-width: 1000px) {
        width: 30%;
      }
    `}
`;
const OverviewLabel = styled.div`
  font-size: 14px;
  color: ${colors.grey.darkMedium};
  margin-bottom: 4px;
`;
const OverviewValue = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  margin: 0;

  a,
  &[href] {
    color: inherit;
    word-break: break-all;

    &:hover {
      color: ${colors.linkHover.light};
      text-decoration: underline;
    }
  }
`;

const GalleryContentContainer = styled.div`
  margin-block: 2rem;
`;

const GalleryContentItem = styled.div`
  margin-block: 2rem;
  position: relative;
`;

const VideoCaption = styled.span`
  font-size: 0.8rem;
  text-align: center;
  width: 100%;
  display: inline-block;
  margin-top: 0.8rem;
`;

const BlankAuctionHouseProjectSection = () => {
  const isMobile = !useMediaQuery(`(min-width: ${breakpoints.tablet} )`);

  const goBack = () => {
    navigate(-1);
  };

  // TODO: source data from data-source
  const randomData = {
    date: new Date(),
    title: "Blank Auction House",
    clientName: "Blank",
    projectName: "Blank Auction House",
    role: "React developer",
    year: "2022",
    cover_src:
      "https://res.cloudinary.com/parmeetsinghasija/video/upload/v1648038674/projects/condexo-pay/condexo-pay__landing-page--old_zxl90m_gq9t2z.mp4",
    mobile_cover_src:
      "https://res.cloudinary.com/parmeetsinghasija/video/upload/v1648038638/projects/condexo-pay/condex-pay__landing-page--mobile_dfw2r8_mpvl3n.mp4",
    clientCountry: "United Kingdom",
    servicesProvided: "Front-end development",
    industry: "Web3, E-Commerce",
    techStack: ["Javascript", "React", "Next.js", "Chakra UI", "Framer Motion"],
    projectLink: "https://www.auctionhouse.blankstudio.art/",
    clientReviews: [],
  };

  const mediaLinks = {
    myPayments:
      "https://res.cloudinary.com/parmeetsinghasija/video/upload/v1648038599/projects/condexo-pay/condexo-pay__my-payments_crskpm_xlqpif.mp4",
    bolletini:
      "https://res.cloudinary.com/parmeetsinghasija/video/upload/v1648038634/projects/condexo-pay/condexo-pay__bolettini-flow_rmytnt_vn8uf3.mp4",
    giftCard:
      "https://res.cloudinary.com/parmeetsinghasija/video/upload/v1648038626/projects/condexo-pay/condexo-pay__gift-card_nmzwxf_fqtwhi.mp4",
  };

  return (
    <>
      <BlogContainer>
        {isMobile && (
          <Flex spaceBetween>
            <IconButton
              bgColor="#bbb"
              iconColor="#000"
              style={{ marginLeft: "-12px" }}
              onClick={goBack}
              ariaLabel="Go back"
            >
              <FiChevronLeft />
            </IconButton>
            {/* <SocialMediaButtons shareLinks={shareLinks} isMobile={true} /> */}
          </Flex>
        )}
        <ContainerScroll
          titleComponent={<BlogTitle>{randomData.title}</BlogTitle>}
          role={randomData.role}
        >
          <ProjectHero src={randomData.cover_src} alt={randomData.title} />
        </ContainerScroll>
        <OverviewSection>
          <OverviewItemContainer>
            <OverviewItem isSeventyPercent>
              <OverviewLabel>Client</OverviewLabel>
              <OverviewValue>{randomData.clientName}</OverviewValue>
            </OverviewItem>
            <OverviewItem isThirtyPercent>
              <OverviewLabel>Country</OverviewLabel>
              <OverviewValue>{randomData.clientCountry}</OverviewValue>
            </OverviewItem>
          </OverviewItemContainer>
          <OverviewItemContainer>
            <OverviewItem isSeventyPercent>
              <OverviewLabel>Services provided</OverviewLabel>
              <OverviewValue>{randomData.servicesProvided}</OverviewValue>
            </OverviewItem>
            <OverviewItem isThirtyPercent>
              <OverviewLabel>Industry</OverviewLabel>
              <OverviewValue>{randomData.industry}</OverviewValue>
            </OverviewItem>
          </OverviewItemContainer>
          {isMobile && (
            <OverviewItem isHundredPercent>
              <OverviewLabel>Year</OverviewLabel>
              <OverviewValue>{randomData.year}</OverviewValue>
            </OverviewItem>
          )}
          <OverviewItem isHundredPercent>
            <OverviewLabel>Tech stack</OverviewLabel>
            <OverviewValue>{randomData.techStack.join(", ")}</OverviewValue>
          </OverviewItem>
          {randomData.projectLink ? (
            <OverviewItem>
              <OverviewLabel>Project link</OverviewLabel>
              <OverviewValue>
                <a
                  href={randomData.projectLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {randomData.projectLink}
                </a>
              </OverviewValue>
            </OverviewItem>
          ) : null}
        </OverviewSection>
        <BlogContentContainer>
          <section>
            <h4>Challenge</h4>
            <p>
              Web3 industry has been growing rapidly, and the NFT space in
              particular has seen a lot of traction, with the highest one
              selling for $91.8 Million. The client wanted to provide users with
              a marketplace which could assist in the sale and purchase of NFT
              assets. While also allowing them to participate in raffle draws
              and buy the client's merchandise.
            </p>
            <VideoContainer>
              <Video autoPlay muted loop src={mediaLinks.myPayments} />
            </VideoContainer>
          </section>
          <section>
            <h4>Process</h4>
            <p>
              The project started with meetings with the product team, followed
              up meetings with the design and development team. The design team
              had UI designs ready in Figma to be used for reference for
              development. My role in this project was to work as a front-end
              developer and ensure that these designs are converted into a
              pixel-perfect website using React, JavaScript, and Chakra UI.
              Several 3rd party libraries like Framer Motion (animations), React
              hook form (form), React Query (API calls) and Date Fns (date
              manipulation) were integrated. Discord, emails, and daily standups
              ensured a smooth communication within the team. Agile methodology
              was followed while developing this product. On successful
              completion of the MVP version of the website, the website was made
              available on a publicly accessible URL.
              <br />
            </p>
            <VideoContainer>
              <Video autoPlay muted loop src={mediaLinks.bolletini} />
            </VideoContainer>
          </section>
          <section>
            <h4>Outcome</h4>
            <p>
              An MVP version of the marketplace platform was successfully
              delivered, which enabled the beta users to trade and invest in
              NFTs. These NFT enthusiasts were able to have a seamless and
              smooth experience while using the platform with large-sized
              animated images and canvases.
            </p>
            <VideoContainer>
              <Video autoPlay muted loop src={mediaLinks.giftCard} />
            </VideoContainer>
          </section>

          <section>
            <h4>Testimonials</h4>
            <Testimonials showMore={false} reviews={randomData.clientReviews} />
          </section>
          {/*     <br />
        <br />
        <br />
        <br />
        <br />
        <h4>Gallery</h4>
        <GalleryContentContainer>
          <GalleryContentItem>
            <VideoContainer>
              <Video autoPlay muted loop src={mediaLinks.giftCard} />
            </VideoContainer>
            <VideoCaption>My payments</VideoCaption>
          </GalleryContentItem>
          <GalleryContentItem>
            <VideoContainer>
              <Video autoPlay muted loop src={mediaLinks.giftCard} />
            </VideoContainer>
          </GalleryContentItem>
        </GalleryContentContainer> */}
        </BlogContentContainer>
      </BlogContainer>
      <ContactMeSection />
    </>
  );
};

export default BlankAuctionHouseProjectSection;
